module.exports = __webpack_public_path__ + "static/artworking-2-7ea798efc6c0d1e4d92304a650a44189.jpg";